import { WatchQueryFetchPolicy } from '@apollo/client';

import { useCurrentClassVar } from 'approot/classes/classes.hooks';
import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import { GET_CLASS_STUDENTS } from './students.graphql';
import type {
  GetClassStudentsQuery,
  GetClassStudentsQueryVariables,
} from './students.graphql.generated';

type Props = {
  fetchPolicy?: WatchQueryFetchPolicy;
  classId?: number;
};

export const useGetClassStudents = (props?: Props) => {
  const { fetchPolicy = 'cache-and-network', classId } = props || {};

  const currentClass = useCurrentClassVar();

  const { data, loading, error } = useLoggingQuery<
    GetClassStudentsQuery,
    GetClassStudentsQueryVariables
  >(GET_CLASS_STUDENTS, {
    skip: !currentClass?.id,
    fetchPolicy,
    variables: {
      input: {
        classId: classId || currentClass?.id!,
      },
    },
  });

  const students = data?.getClassStudents || [];

  return {
    data,
    loading,
    error,
    hasStudents: students.length > 0,
  };
};
